import { dashFetch } from "@/api/client";
import type { PageContentSearchPayload } from "@/types/pageContentSearch";

export async function searchPageContent(
  domain: string,
  query: string,
  opts?: { limit?: number; minScore?: number; expandSynonyms?: boolean }
): Promise<PageContentSearchPayload> {
  const params = new URLSearchParams();
  params.set("domain", domain);
  params.set("q", query);
  if (opts?.limit != null) params.set("limit", String(opts.limit));
  if (opts?.minScore != null) params.set("minScore", String(opts.minScore));
  if (opts?.expandSynonyms === false) params.set("expandSynonyms", "0");

  const data = await dashFetch<PageContentSearchPayload>(
    `/dashboard/api/pages/content-search?${params.toString()}`,
    { cache: "no-store", site: domain }
  );

  if (!data?.ok && data?.error) {
    throw new Error(String(data.error));
  }
  return data;
}
